// @flow
import React, {PureComponent} from "react";
import {
    AirportPolygonName,
    TerminalSelectionContainer, TerminalSelectionOptionsContainer, TerminalSelectionTitle,
    TerminalSelectionVerticalDelimiter
} from "./TerminalSelectionStyle";
import TerminalSelectionButton from "./TerminalSelectionButton";

type OwnProps = {|
    polygon: Object,
    terminalSelectionLogo: string,
    selectionTitle: string,
    terminalStops: Array<Object>,
    onTerminalSelect: () => mixed,
|};

type State = {
    active: boolean,
};

class TerminalSelection extends PureComponent<OwnProps, State> {

    onTouchStart: () => void;
    onTouchEnd: () => void;

    constructor() {
        super();

        this.onTouchStart = this.onTouchStart.bind(this);
        this.onTouchEnd = this.onTouchEnd.bind(this);

        this.state = {
            active: false
        };
    }

    onTouchStart() {
        this.setState({active: true});
    }

    onTouchEnd() {
        this.setState({active: false});
    }
    render() {
        return (
            <TerminalSelectionContainer
                onMouseDown={this.onTouchStart}
                onTouchStart={this.onTouchStart}
                onMouseUp={this.onTouchEnd}
                onTouchEnd={this.onTouchEnd}
            >
                <div>
                    <img src={this.props.terminalSelectionLogo} alt="terminal"/>
                    <TerminalSelectionVerticalDelimiter/>
                    <AirportPolygonName>{this.props.polygon.label}</AirportPolygonName>
                </div>
                <div>
                    <TerminalSelectionTitle>
                        {this.props.selectionTitle}
                    </TerminalSelectionTitle>
                </div>
                <TerminalSelectionOptionsContainer>
                    {this.props.terminalStops && this.props.terminalStops.map((terminal) =>
                        <TerminalSelectionButton
                            key={terminal.label}
                            terminal={terminal}
                            parentActive={this.state.active}
                            onTerminalSelect={this.props.onTerminalSelect}
                        />
                    )}
                </TerminalSelectionOptionsContainer>
            </TerminalSelectionContainer>
        );
    }
}

export default TerminalSelection;



// WEBPACK FOOTER //
// ./src/Components/Screen/RideRequest/TerminalSelection/TerminalSelection.js